exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.news-wrapper[data-v-317cf022] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 10px 6px 10px 10px;\n}\n.news-wrapper .right-content[data-v-317cf022] {\n  overflow: hidden;\n  width: 80%;\n  margin: 0 auto;\n  padding-right: 24px;\n  padding-left: 24px;\n  height: calc(100% - 40px);\n}\n", ""]);

// exports
